(() => {
  const initialize = (section) => {
    if (
      !section ||
      section.dataset.croStickyCartInitialized === "true"
    ) {
      return;
    }

    section.dataset.croStickyCartInitialized = "true";

    const optionSelects = Array.from(
      section.querySelectorAll(
        "[data-cro-sticky-option]",
      ),
    );

    const variantInput = section.querySelector(
      "[data-cro-sticky-variant]",
    );

    const variantsScript = section.querySelector(
      "[data-cro-sticky-variants]",
    );

    const priceElement = section.querySelector(
      "[data-cro-sticky-price]",
    );

    const comparePriceElement =
      section.querySelector(
        "[data-cro-sticky-compare-price]",
      );

    const addButton = section.querySelector(
      "[data-cro-sticky-add]",
    );

    const buttonText = section.querySelector(
      "[data-cro-sticky-button-text]",
    );

    const statusElement = section.querySelector(
      "[data-cro-sticky-status]",
    );

    if (
      !variantInput ||
      !variantsScript ||
      !addButton ||
      !buttonText
    ) {
      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(
        variantsScript.textContent || "[]",
      );
    } catch {
      variants = [];
    }

    const formatMoney = (amount) => {
      const value = Number(amount || 0) / 100;

      const currency =
        window.Shopify?.currency?.active ||
        "USD";

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || "en",
          {
            style: "currency",
            currency,
          },
        ).format(value);
      } catch {
        return `${currency} ${value.toFixed(2)}`;
      }
    };

    const findSelectedVariant = () => {
      const selectedOptions = optionSelects
        .slice()
        .sort(
          (first, second) =>
            Number(first.dataset.optionIndex) -
            Number(second.dataset.optionIndex),
        )
        .map((select) => select.value);

      if (!selectedOptions.length) {
        return variants.find(
          (variant) =>
            String(variant.id) ===
            String(variantInput.value),
        );
      }

      return variants.find(
        (variant) =>
          Array.isArray(variant.options) &&
          variant.options.length ===
            selectedOptions.length &&
          variant.options.every(
            (value, index) =>
              String(value) ===
              String(selectedOptions[index]),
          ),
      );
    };

    const showStatus = (
      message,
      type = "success",
    ) => {
      if (!statusElement) {
        return;
      }

      statusElement.textContent = message;
      statusElement.dataset.statusType = type;
      statusElement.classList.add("is-visible");

      window.clearTimeout(
        Number(
          statusElement.dataset.hideTimer || 0,
        ),
      );

      const timer = window.setTimeout(() => {
        statusElement.classList.remove(
          "is-visible",
        );
      }, 2800);

      statusElement.dataset.hideTimer =
        String(timer);
    };

    const updateVariant = () => {
      const variant = findSelectedVariant();

      const availableLabel =
        addButton.dataset.availableLabel ||
        "Add to cart";

      const soldOutLabel =
        addButton.dataset.soldOutLabel ||
        "Sold out";

      if (!variant) {
        variantInput.value = "";
        addButton.disabled = true;
        buttonText.textContent = "Unavailable";

        comparePriceElement?.classList.add(
          "is-hidden",
        );

        return;
      }

      variantInput.value = String(variant.id);

      if (priceElement) {
        priceElement.textContent =
          formatMoney(variant.price);
      }

      if (comparePriceElement) {
        const onSale =
          Number(variant.compare_at_price || 0) >
          Number(variant.price || 0);

        comparePriceElement.textContent =
          onSale
            ? formatMoney(
                variant.compare_at_price,
              )
            : "";

        comparePriceElement.classList.toggle(
          "is-hidden",
          !onSale,
        );
      }

      addButton.disabled = !variant.available;

      buttonText.textContent =
        variant.available
          ? availableLabel
          : soldOutLabel;
    };

    const updateVisibility = () => {
      const selectors = [
        'form[action*="/cart/add"] button[type="submit"]',
        'form[action*="/cart/add"] input[type="submit"]',
        '[name="add"]',
        "[data-add-to-cart]",
        ".product-form__submit",
      ];

      const primaryAddButton = Array.from(
        document.querySelectorAll(
          selectors.join(","),
        ),
      ).find(
        (element) =>
          !section.contains(element) &&
          element.offsetParent !== null,
      );

      if (!primaryAddButton) {
        section.classList.add("is-visible");
        return;
      }

      const bounds =
        primaryAddButton.getBoundingClientRect();

      const visible =
        bounds.bottom > 0 &&
        bounds.top < window.innerHeight;

      section.classList.toggle(
        "is-visible",
        !visible,
      );
    };

    optionSelects.forEach((select) => {
      select.addEventListener(
        "change",
        updateVariant,
      );
    });

    const submitToCartPage = (variantId) => {
      const root =
        window.Shopify?.routes?.root ||
        "/";

      const normalizedRoot =
        root.endsWith("/")
          ? root
          : `${root}/`;

      /*
       * Use Shopify's normal HTML cart form for cart-page mode.
       *
       * This intentionally avoids /cart/add.js and JSON parsing.
       * It is also the safe fallback when a merchant selects
       * cart-drawer mode but the active theme does not expose
       * a compatible native cart drawer.
       */
      const form =
        document.createElement("form");

      form.method = "POST";
      form.action =
        `${normalizedRoot}cart/add`;
      form.style.display = "none";

      const idField =
        document.createElement("input");

      idField.type = "hidden";
      idField.name = "id";
      idField.value =
        String(variantId);

      const quantityField =
        document.createElement("input");

      quantityField.type = "hidden";
      quantityField.name = "quantity";
      quantityField.value = "1";

      const returnField =
        document.createElement("input");

      returnField.type = "hidden";
      returnField.name = "return_to";
      returnField.value =
        `${normalizedRoot}cart`;

      form.appendChild(idField);
      form.appendChild(
        quantityField,
      );
      form.appendChild(
        returnField,
      );

      document.body.appendChild(form);
      form.submit();
    };

    const findNativeProductForm = () => {
      const forms = Array.from(
        document.querySelectorAll(
          'form[action*="/cart/add"]',
        ),
      ).filter(
        (form) =>
          !section.contains(form) &&
          !form.closest(".quick-add"),
      );

      if (!forms.length) {
        return null;
      }

      return forms.reduce(
        (largest, current) => {
          const largestHeight =
            largest?.offsetHeight || 0;

          const currentHeight =
            current?.offsetHeight || 0;

          return currentHeight >
            largestHeight
            ? current
            : largest;
        },
        forms[0],
      );
    };

    const findNativeAddButton = (
      form,
    ) => {
      if (!form) {
        return null;
      }

      return (
        form.querySelector(
          'button[type="submit"][name="add"]',
        ) ||
        form.querySelector(
          'button[type="submit"]',
        ) ||
        form.querySelector(
          'input[type="submit"][name="add"]',
        ) ||
        form.querySelector(
          'input[type="submit"]',
        )
      );
    };

    const syncNativeProductForm = (
      form,
      variantId,
      quantity = 1,
    ) => {
      if (!form) {
        return false;
      }

      const idInput =
        form.querySelector(
          '[name="id"]',
        );

      if (!idInput) {
        return false;
      }

      idInput.value =
        String(variantId);

      idInput.dispatchEvent(
        new Event("change", {
          bubbles: true,
        }),
      );

      let quantityInput =
        form.querySelector(
          '[name="quantity"]',
        );

      if (!quantityInput) {
        quantityInput =
          document.createElement(
            "input",
          );

        quantityInput.type =
          "hidden";
        quantityInput.name =
          "quantity";

        form.appendChild(
          quantityInput,
        );
      }

      quantityInput.value =
        String(quantity);

      quantityInput.dispatchEvent(
        new Event("change", {
          bubbles: true,
        }),
      );

      return true;
    };

    addButton.addEventListener(
      "click",
      async () => {
        const variantId =
          variantInput.value;

        if (
          !variantId ||
          addButton.disabled
        ) {
          return;
        }

        const requestedBehavior =
          section.dataset.cartBehavior ||
          "drawer";

        /*
         * CART PAGE MODE
         *
         * Keep the existing working behavior unchanged.
         */
        if (
          requestedBehavior ===
          "page"
        ) {
          submitToCartPage(
            variantId,
          );

          return;
        }

        /*
         * DRAWER MODE
         *
         * Prefer the theme's own product form and real
         * Add to Cart button. This mirrors the compatibility
         * approach used by mature Sticky ATC apps.
         *
         * The theme remains responsible for:
         * - /cart/add request
         * - cart drawer rendering
         * - cart drawer opening
         * - analytics
         * - upsells
         * - third-party cart integrations
         */
        const nativeForm =
          findNativeProductForm();

        const nativeAddButton =
          findNativeAddButton(
            nativeForm,
          );

        if (
          nativeForm &&
          nativeAddButton &&
          !nativeAddButton.disabled
        ) {
          const synced =
            syncNativeProductForm(
              nativeForm,
              variantId,
              1,
            );

          if (synced) {
            console.log(
              "[CRO Sticky Cart] Using theme native Add to Cart flow.",
              {
                form:
                  nativeForm,
                button:
                  nativeAddButton,
                variantId:
                  String(
                    variantId,
                  ),
              },
            );

            addButton.disabled =
              true;

            addButton.classList.add(
              "is-loading",
            );

            buttonText.textContent =
              "Adding...";

            try {
              nativeAddButton.click();

              window.setTimeout(
                () => {
                  addButton.classList.remove(
                    "is-loading",
                  );

                  updateVariant();
                },
                1200,
              );
            } catch (error) {
              addButton.classList.remove(
                "is-loading",
              );

              updateVariant();

              console.error(
                "[CRO Sticky Cart] Native theme Add to Cart click failed.",
                error,
              );

              showStatus(
                "Unable to add this product.",
                "error",
              );
            }

            return;
          }
        }

        /*
         * FALLBACK DRAWER MODE
         *
         * Only use CRO's own AJAX integration when the theme
         * does not expose a usable native product form/button.
         */
        const cartDrawer =
          document.querySelector(
            "cart-drawer",
          );

        const supportsNativeCartDrawer =
          Boolean(
            cartDrawer &&
            typeof cartDrawer
              .getSectionsToRender ===
              "function" &&
            typeof cartDrawer
              .renderContents ===
              "function",
          );

        if (
          !supportsNativeCartDrawer
        ) {
          console.error(
            "[CRO Sticky Cart] No usable theme Add to Cart button or compatible cart drawer was found.",
          );

          showStatus(
            "This theme's cart drawer could not be opened.",
            "error",
          );

          return;
        }

        addButton.disabled = true;
        addButton.classList.add(
          "is-loading",
        );
        buttonText.textContent =
          "Adding...";

        try {
          const root =
            window.Shopify?.routes?.root ||
            "/";

          const normalizedRoot =
            root.endsWith("/")
              ? root
              : `${root}/`;

          const requestBody = {
            items: [
              {
                id: Number(
                  variantId,
                ),
                quantity: 1,
              },
            ],
          };

          try {
            const drawerSections =
              cartDrawer
                .getSectionsToRender();

            const sectionIds =
              Array.isArray(
                drawerSections,
              )
                ? drawerSections
                    .map(
                      (item) =>
                        item?.id,
                    )
                    .filter(Boolean)
                : [];

            if (
              sectionIds.length
            ) {
              requestBody.sections =
                sectionIds.join(",");

              requestBody.sections_url =
                window.location.pathname;
            }

            if (
              typeof cartDrawer
                .setActiveElement ===
              "function"
            ) {
              cartDrawer
                .setActiveElement(
                  addButton,
                );
            }
          } catch (error) {
            console.warn(
              "[CRO Sticky Cart] Native cart drawer preparation failed.",
              error,
            );
          }

          const result =
            await new Promise(
              (
                resolve,
                reject,
              ) => {
                const xhr =
                  new XMLHttpRequest();

                xhr.open(
                  "POST",
                  `${normalizedRoot}cart/add.js`,
                  true,
                );

                xhr.setRequestHeader(
                  "Content-Type",
                  "application/json",
                );

                xhr.setRequestHeader(
                  "Accept",
                  "application/json",
                );

                xhr.onload =
                  () => {
                    const responseText =
                      xhr.responseText ||
                      "";

                    let parsed = null;

                    try {
                      parsed =
                        JSON.parse(
                          responseText,
                        );
                    } catch (
                      error
                    ) {
                      reject(
                        new Error(
                          "Unable to update the cart.",
                        ),
                      );

                      return;
                    }

                    if (
                      xhr.status <
                        200 ||
                      xhr.status >=
                        300
                    ) {
                      reject(
                        new Error(
                          parsed
                            ?.description ||
                          parsed
                            ?.message ||
                          "Unable to add this product.",
                        ),
                      );

                      return;
                    }

                    resolve(
                      parsed,
                    );
                  };

                xhr.onerror =
                  () => {
                    reject(
                      new Error(
                        "Unable to connect to the cart.",
                      ),
                    );
                  };

                xhr.send(
                  JSON.stringify(
                    requestBody,
                  ),
                );
              },
            );

          if (
            !result?.sections
          ) {
            throw new Error(
              "Unable to refresh the cart drawer.",
            );
          }

          cartDrawer.renderContents(
            result,
          );

          if (
            typeof cartDrawer.open ===
            "function"
          ) {
            window.requestAnimationFrame(
              () => {
                cartDrawer.open();
              },
            );
          }

          showStatus(
            "Added to your cart",
          );
        } catch (error) {
          console.error(
            "[CRO Sticky Cart] AJAX drawer fallback failed.",
            error,
          );

          showStatus(
            error instanceof Error
              ? error.message
              : "Unable to add this product.",
            "error",
          );
        } finally {
          addButton.classList.remove(
            "is-loading",
          );

          updateVariant();
        }
      },
    );

    window.addEventListener(
      "scroll",
      updateVisibility,
      {
        passive: true,
      },
    );

    window.addEventListener(
      "resize",
      updateVisibility,
      {
        passive: true,
      },
    );

    updateVariant();
    updateVisibility();

    window.setTimeout(
      updateVisibility,
      300,
    );
  };

  const initializeAll = (root = document) => {
    if (root.matches?.("[data-cro-sticky-cart]")) {
      initialize(root);
    }

    root
      .querySelectorAll?.(
        "[data-cro-sticky-cart]",
      )
      .forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeAll(),
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => initializeAll(event.target),
  );
})();
